// This file auto-imports all controllers
import { application } from "./application.js"

import TooltipController from "./tooltip_controller.js"
import CopyLinkController from "./copy_link_controller.js"
import ClickableRowController from "./clickable_row_controller.js"
import FieldListController from "./field_list_controller.js"
import LegalHeadingsController from "./legal_headings_controller.js"
import MarkdownEditorController from "./markdown_editor_controller.js"
import FlatpickrController from "./flatpickr_controller.js"
import ReplaceMeController from "./replace_me_controller.js"
import DiscountKindController from "./discount_kind_controller.js"

application.register("tooltip", TooltipController)
application.register("copy-link", CopyLinkController)
application.register("clickable-row", ClickableRowController)
application.register("field-list", FieldListController)
application.register("legal-headings", LegalHeadingsController)
application.register("markdown-editor", MarkdownEditorController)
application.register("flatpickr", FlatpickrController)
application.register("replace-me", ReplaceMeController)
application.register("discount-kind", DiscountKindController)


